import React from "react" ;
import OrgDashAppBodyHeader from "root/Wieldy/ApplicationModules/OrganisationDashboard/Body/OrgDashAppBodyHeader";
import {Route, Switch} from "react-router-dom";
import {PATH_DASHBOARD_ROOT} from "root/Wieldy/routePaths";

import ScrollRails from "../../Common/Body/ScrollRails";
import OrgDashboardTab from "root/Wieldy/ApplicationModules/OrganisationDashboard/Body/OrgDashboardTab";

const OrgDashAppBody= (props) =>
{
    return (
    <div className="dt-module__container">
        <OrgDashAppBodyHeader />
        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>
            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={PATH_DASHBOARD_ROOT} render={(thisprops) => <OrgDashboardTab {...thisprops}/>}/>
                    </Switch>
                </div>
            </div>
            <ScrollRails />
        </div>
    </div>
    ) ;
}

export default OrgDashAppBody;
